module.exports = "<label>\r\n  <ng-content></ng-content>\r\n  <input type=\"file\"\r\n  class=\"ng4-files-upload-btn\"\r\n  [multiple]=\"maxFilesCount > 1\"\r\n  #spyNg4FilesInputSpy\r\n  accept=\"{{acceptExtensions}}\"\r\n  (change)=\"onChange(spyNg4FilesInputSpy.files); spyNg4FilesInputSpy.value=''\" />\r\n</label>\r\n"


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/node_modules/angular4-files-upload/src/app/ng4-files/components/ng4-files-click/ng4-files-click.component.html
// module id = ../../../../angular4-files-upload/src/app/ng4-files/components/ng4-files-click/ng4-files-click.component.html
// module chunks = common